import { AuthTokenService } from "@src/application/services";
import type { IAuthTokenService } from "@src/domain/interfaces";
import { Auth0Service } from "./Auth0Service";
import { AdminAuthLoginService } from "./AdminAuthLoginService";

export class AuthUserTokenService extends AuthTokenService implements IAuthTokenService {
  private readonly auth0Service: Auth0Service;
  private readonly adminAuthLoginService: AdminAuthLoginService;

  constructor() {
    super();
    this.auth0Service = Auth0Service.getInstance();
    this.adminAuthLoginService = AdminAuthLoginService.getInstance();
  }
  async getAuthAccessToken() {
    const token = await this.auth0Service.getAccessToken();
    return token;
  }
  async getAdminAccessToken(){
    const adminAccessToken = await this.adminAuthLoginService.getAccessToken();
    return adminAccessToken;
  }
  async getAdminRefreshToken(){
    const adminRefreshToken = await this.adminAuthLoginService.getRefreshToken();
    return adminRefreshToken;
  }
}